import { createSelector } from '@reduxjs/toolkit';

import { useReduxSelector } from '../../../hooks';

import { userSelector } from './root';

export const userIsAuthenticatedSelector = createSelector(userSelector, state => state.isAuthenticated);
export function useUserIsAuthenticatedSelector(): boolean {
  return useReduxSelector(userIsAuthenticatedSelector);
}

export const userIsAgentSelector = createSelector(userSelector, state => Boolean(state.isAgent && !state.isBuilder));
export function useUserIsAgentSelector(): boolean {
  return useReduxSelector(userIsAgentSelector);
}
